import { render, staticRenderFns } from "./RedazioneDetail.vue?vue&type=template&id=d36c7c8c&"
import script from "./RedazioneDetail.vue?vue&type=script&lang=js&"
export * from "./RedazioneDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports